<template>
    <div class="CViewToggle inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white p-1 dark:border-default dark:bg-surface-card">
        <button
            v-for="option in options"
            :key="option.value"
            :title="option.label"
            :class="[
                'flex h-8 w-8 items-center justify-center rounded-full transition-all',
                modelValue === option.value
                    ? 'bg-gray-900 text-white dark:bg-white dark:text-gray-900'
                    : 'text-gray-500 hover:text-gray-800 dark:text-txt-body dark:hover:text-white'
            ]"
            @click="$emit('update:modelValue', option.value)"
        >
            <Icon :name="option.icon" class="size-5" />
        </button>
    </div>
</template>

<script setup lang="ts">
export type ViewMode = 'cards' | 'rows'

interface ViewOption {
    value: ViewMode
    label: string
    icon: string
}

interface Props {
    modelValue: ViewMode
}

defineProps<Props>()
defineEmits<{
    'update:modelValue': [value: ViewMode]
}>()

const options: ViewOption[] = [
    {
        value: 'cards',
        label: 'Zobrazenie v kartách',
        icon: 'heroicons:squares-2x2'
    },
    {
        value: 'rows',
        label: 'Zobrazenie v riadkoch',
        icon: 'heroicons:list-bullet'
    }
]
</script>
